module.exports = __webpack_public_path__ + "img/Jenkins.ec0c9527.png";